// extracted by mini-css-extract-plugin
export default {"wrapper":"create-modal_wrapper__svstu","title":"create-modal_title__9RdcC","boxFirst":"create-modal_boxFirst__T6FPP","boxType":"create-modal_boxType__1XPjn"};